<template>
  <div class="box-cl"
    :class="[
      {'border': bordered},
      {[`border-${border}`]: border},
       align || justify ? 'd-flex' : '',
      {[`align-items-${align}`]: align},
      {[`justify-content-${justify}`]: justify}
    ]"
    :style="[
      {borderRadius: radius + 'px'},
      {backgroundColor: bg},
      {width: w},
      {height: h},
      {padding: p},
      [dashed ? {borderStyle: 'dashed'} : '']
    ]">
    <slot />
  </div>
</template>

<script>
  // import BaseIcon from '@/components/BaseIcon'
  export default {
    components: {
      // BaseIcon
    },
    props: {
      bg: {
        type: String,
        default: '' 
      },
      radius: {
        type: Number,
        default: 30
      },
      bordered: {
        type: Boolean,
        default: false
      },
      dashed: Boolean,
      border: {
        type: String,
        default: '1'
      },
      align: {
        type: String,
        default: ''
      },
      justify: {
        type: String,
        default: ''
      },
      w: {
        type: String,
        default: ''
      },
      h: {
        type: String,
        default: ''
      },
      p: {
        type: String,
        default: ''
      }
    }
    // p
  }
</script>

<style lang="scss" scoped>

</style>